import React from 'react';

import PaymentsInfo from '@app/components/Pages/PaymentsProcessing/PaymentsInfo';
import Terminals from '@app/components/Pages/PaymentsProcessing/Terminals';
import ScanPay from '@app/components/Pages/PaymentsProcessing/ScanPay';
import CardNotPresent from '@app/components/Pages/PaymentsProcessing/CardNotPresent';
import RequestDemo from '@app/components/Pages/PaymentsProcessing/RequestDemo';

import '@app/scss/pages/paymentsProcessing.scss';

const PaymentsProcessing: React.FC = () => {
	return <div className="payments-processing">
		<PaymentsInfo />
		<Terminals />
		<ScanPay />
		<CardNotPresent />
		<RequestDemo />
	</div>;
};

export default PaymentsProcessing;
